import React, { Fragment, useEffect, useState } from "react";
import Hero from "../../components/hero";

import AboutS2 from "../../components/AboutS2";
import Footer from "../../components/footer";
import OurCompanies from "../../components/OurCompanies";
import PartnerSection from "../../components/PartnerSection";
import ProjectSection4 from "../../components/ProjectSection4";
import Scrollbar from "../../components/scrollbar";
import Service5 from "../../components/Service5";
import { GET_MENUS_ALL_NESTED } from "../../constant/constants";

const HomePage = () => {
  const [homeId, setHomeId] = useState();
  const [serviceId, setServiceId] = useState();

  useEffect(() => {
    fetch(`${GET_MENUS_ALL_NESTED}`)
      .then((response) => response.json())
      .then((data) => {
        data.menus.find((e) => (e.name === "Home" ? setHomeId(e.id) : null));
        data.menus.find((e) =>
          e.name === "Service" ? setServiceId(e.id) : null
        );
      })
      .catch(() => {});
  }, []);
  //console.log("nnnnnnn", homeId);

  return (
    <Fragment>
      <Hero />
      <OurCompanies id={homeId} tClass={"wpo-testimonial-area-s3"} />
      <AboutS2 id={homeId} />
      <Service5 id={serviceId} />
      <ProjectSection4 id={homeId} />
      <PartnerSection id={homeId} />
      <Scrollbar />
      <Footer />
    </Fragment>
  );
};
export default HomePage;
